import { useEffect } from 'react';
import { Box, Chip, TextField, Typography } from '@material-ui/core';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { slugifyImageName } from './slug';
import { useTemplateDefaults } from './useTemplateDefaults';

export interface ImagePreviewFieldProps {
  onChange: (value: string) => void;
  formData?: string;
  formContext?: {
    formData?: {
      repoName?: string;
      name?: string;
      [key: string]: any;
    };
    [key: string]: any;
  };
  uiSchema?: {
    'ui:options'?: {
      registryNamespace?: string;
    };
    [key: string]: any;
  };
  idSchema?: {
    $id: string;
  };
  schema?: {
    title?: string;
    description?: string;
  };
}

export const ImagePreviewFieldComponent = (props: ImagePreviewFieldProps) => {
  const { onChange, formData, formContext, idSchema, schema } = props;

  const { defaults, error } = useTemplateDefaults();
  const registryNamespace = defaults?.imageHub;

  const rawRepoName =
    formContext?.formData?.repoName || formContext?.formData?.name || '';
  const normalizedSlug = slugifyImageName(rawRepoName);
  const fullImage = !registryNamespace
    ? ''
    : normalizedSlug
    ? `${registryNamespace}/${normalizedSlug}`
    : 'No repository name provided';

  useEffect(() => {
    if (normalizedSlug && formData !== normalizedSlug) {
      onChange(normalizedSlug);
    }
  }, [normalizedSlug, formData, onChange]);

  return (
    <Box marginY={1}>
      <TextField
        id={idSchema?.$id ?? 'image-preview-field'}
        label={schema?.title ?? 'Docker Image Preview (Read-only)'}
        value={fullImage}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
        helperText={
          error ||
          (!defaults
            ? 'Loading…'
            : schema?.description ||
              'Automatically generated Docker image tag normalized from repository name with Vietnamese diacritics removed.')
        }
      />
      {normalizedSlug && (
        <Box display="flex" alignItems="center" mt={0.5} mb={1}>
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ marginRight: 8 }}
          >
            Resolved Slug:
          </Typography>
          <Chip
            size="small"
            label={normalizedSlug}
            variant="outlined"
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export const ImagePreviewField = createFormField({
  name: 'ImagePreviewField',
  component: ImagePreviewFieldComponent as any,
});
